var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHotelMystaysLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1A1311",
  d: "m13.866 22.983-2.168 2.189 2.167 2.188 2.167-2.189zM16.034 16.419l-2.17 2.188-2.166-2.188-4.335 4.376 2.17 2.187 2.166-2.187 2.165 2.187 2.168-2.187 2.166 2.187 2.167-2.187z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00398D",
  d: "M13.874 0 5.204 8.752l8.668 8.753 8.668-8.752z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#6A6A6A",
  d: "m23.08 9.301-6.499 6.563 4.333 4.375 6.499-6.562zM4.656 9.306.321 13.683l6.5 6.564 4.336-4.377z"
})));
export default SvgHotelMystaysLogo;